import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Catalogue from './views/Catalogue.vue'
import CatalogueAdvanced from './views/CatalogueAdvanced.vue'
import Interchange from './views/Interchange.vue'
import Part from './views/Part.vue'
import Tecdoc from './views/Tecdoc.vue'
import Arrivals from './views/Arrivals.vue'
import Quotes from './views/Quotes.vue'
import QuotesSubmit from './views/QuotesSubmit.vue'
// Error
import Deny from './views/Deny'
import Error from './views/Error'
// Security
import Login from './views/security/Login'
import Forgot from './views/security/Forgot'
import Reset from './views/security/Reset'
import Change from './views/security/Change'
import Register from './views/security/Register'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/403',
      name: '403',
      component: Deny,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/500',
      name: '500',
      component: Error,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        auth: false,
        layout: 'sparse'
      }
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
      meta: {
        auth: false,
        layout: 'sparse'
      }
    },
    {
      path: '/reset',
      name: 'reset',
      component: Reset,
      meta: {
        auth: false,
        layout: 'sparse'
      }
    },
    {
      path: '/change',
      name: 'change',
      component: Change,
      meta: {
        auth: true,
        layout: 'sparse'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        auth: false,
        layout: 'sparse'
      }
    },
    {
      path: '/catalogue/:make?',
      name: 'catalogue',
      component: Catalogue,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/catalogue-advanced',
      name: 'catalogue-advanced',
      component: CatalogueAdvanced,
      meta: { auth: true }
    },
    {
      path: '/interchange',
      name: 'interchange',
      component: Interchange,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/part',
      name: 'part',
      component: Part,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/tecdoc',
      name: 'tecdoc',
      component: Tecdoc,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/new-arrivals',
      name: 'arrivals',
      component: Arrivals,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: Quotes,
      meta: {
        auth: true
      }
    },
    {
      path: '/quotes/submit',
      name: 'quotesSubmit',
      component: QuotesSubmit,
      meta: {
        auth: true
      }
    }
  ]
})
